export default __webpack_public_path__ + "static/22-7bb2528cc457282286deec1d7a38d79f.jpg";